import React, { useEffect, useRef, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { Box, Button, SvgIcon, Tooltip } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import GoogleIcon from '@mui/icons-material/Google';

import AmazonIcon from 'assets/icons/AmazonIcon';
import { ROUTES } from 'enum';

const AMAZON_MIDWAY_UNAVAILABLE_MESSAGE = 'Amazon Midway is temporarily unavailable';

function LoginMethods() {
  const history = useHistory();
  const tooltipTimerRef = useRef(null);
  const [isAmazonTooltipOpen, setIsAmazonTooltipOpen] = useState(false);

  const handleLogin = (method) => (e) => {
    e.preventDefault();
    window.open(`${process.env.REACT_APP_API_URL}/v2/auth/${method}/login`, '_self');
  };

  const showAmazonUnavailableTooltip = (e) => {
    e.preventDefault();
    window.clearTimeout(tooltipTimerRef.current);
    setIsAmazonTooltipOpen(true);
    tooltipTimerRef.current = window.setTimeout(() => {
      setIsAmazonTooltipOpen(false);
    }, 2500);
  };

  useEffect(
    () => () => {
      window.clearTimeout(tooltipTimerRef.current);
    },
    [],
  );

  return (
    <div className="login-form-page--content">
      <Box className="login-form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 2 }}>
        <Button
          variant="text"
          startIcon={<ChevronLeftIcon />}
          onClick={() => history.push(ROUTES.LOGIN)}
          sx={{ fontSize: 24, color: '#6d8994', '&:hover': { bgcolor: 'transparent' } }}
          data-testid="btn-back_login"
        >
          Back
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={handleLogin('google')}
          startIcon={<GoogleIcon />}
          sx={{ fontSize: 18, p: 2 }}
          data-testid="btn-sso_google"
        >
          Continue with Google
        </Button>
        <Tooltip
          arrow
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={AMAZON_MIDWAY_UNAVAILABLE_MESSAGE}
          open={isAmazonTooltipOpen}
          placement="top"
          componentsProps={{ tooltip: { sx: { fontSize: 12 } } }}
        >
          <span
            onClick={showAmazonUnavailableTooltip}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                showAmazonUnavailableTooltip(e);
              }
            }}
            role="button"
            tabIndex={0}
            style={{ display: 'block', width: '100%' }}
          >
            <Button
              fullWidth
              variant="contained"
              startIcon={
                <SvgIcon sx={{ fontSize: 24 }}>
                  <AmazonIcon />
                </SvgIcon>
              }
              sx={{ fontSize: 18, p: 2 }}
              data-testid="btn-sso_amazon"
            >
              Continue with Amazon Midway
            </Button>
          </span>
        </Tooltip>
      </Box>
    </div>
  );
}

export default withRouter(LoginMethods);
